"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllOfferings = exports.BundleOffering = exports.OneOffOffering = exports.SubscriptionOffering = exports.DateInterval = exports.DateType = void 0;
const z = require("zod");
const Billing_1 = require("./Billing");
var DateType;
(function (DateType) {
    DateType["Day"] = "day";
    DateType["Month"] = "month";
    DateType["Year"] = "year";
})(DateType = exports.DateType || (exports.DateType = {}));
exports.DateInterval = z.object({
    number: z.number(),
    unit: z.nativeEnum(DateType),
});
exports.SubscriptionOffering = z.object({
    id: z.string(),
    name: z.string(),
    price: Billing_1.CurrencyAmount,
    description: z.string(),
    possibleNumberOfInstallments: z.number(),
    interval: exports.DateInterval,
    trialPeriod: exports.DateInterval,
});
exports.OneOffOffering = z.object({
    id: z.string(),
    name: z.string(),
    price: Billing_1.CurrencyAmount,
    description: z.string(),
    possibleNumberOfInstallments: z.number(),
});
exports.BundleOffering = z.object({
    id: z.string(),
    name: z.string(),
    price: Billing_1.CurrencyAmount,
    description: z.string(),
    possibleNumberOfInstallments: z.number(),
    oneOffOfferings: z.array(z.object({ id: z.string() })),
    subscriptionOfferings: z.array(z.object({ id: z.string(), paidIterations: z.number(), trialPeriod: exports.DateInterval })),
});
exports.AllOfferings = z.object({
    bundleOfferings: z.array(exports.BundleOffering),
    oneOffOfferings: z.array(exports.OneOffOffering),
    subscriptionOfferings: z.array(exports.SubscriptionOffering),
});
